import * as actionTypes from '../actions/actionTypes';
import moment from "moment";

import { updateObject } from '../utility';

const initialState = {
    origin: '',
    originCity: null,
    originCountry: null,
    originValid: true,
    originTooltip: false,
    destination: '',
    destinationCity: null,
    destinationCountry: null,
    destinationValid: true,
    destinationTooltip: false,
    inputType: null,
    middleContainer: true,
    autoSuggestBox: false,
    startDate: moment(),
    endDate: null
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_ORIGIN_CITY:
            return updateObject(state, { origin: action.city, originCity: action.cityCode, originCountry: action.countryCode, inputType: '', middleContainer: true, autoSuggestBox: false })
        case actionTypes.SET_DESTINATION_CITY:
            return updateObject(state, { destination: action.city, destinationCity: action.cityCode, destinationCountry: action.countryCode, inputType: '', middleContainer: true, autoSuggestBox: false })
        case actionTypes.SEARCH_ORIGIN_CITY:
            return updateObject(state, { origin: action.city, originValid: true, originTooltip: false, inputType: 1, middleContainer: false, autoSuggestBox: true })
        case actionTypes.SEARCH_DESTINATION_CITY:
            return updateObject(state, { destination: action.city, destinationValid: true, destinationTooltip: false, inputType: 2, middleContainer: false, autoSuggestBox: true})
        case actionTypes.SET_ORIGIN_VALIDATION:
            return updateObject(state, { originValid: false, originTooltip: true });
        case actionTypes.SET_DESTINATION_VALIDATION:
            return updateObject(state, { destinationValid: false, destinationTooltip: true });
        case actionTypes.SWITCH_CITY:
            const origin = state.origin;
            const originCity = state.originCity;
            const originCountry = state.originCountry;
            const destination = state.destination;
            const destinationCity = state.destinationCity;
            const destinationCountry = state.destinationCountry;
            return updateObject(state, { origin: destination, originCity: destinationCity, originCountry: destinationCountry, destination: origin, destinationCity: originCity, destinationCountry: originCountry });
        case actionTypes.SET_START_DATE:
            return updateObject(state, { startDate: action.startDate })
        case actionTypes.SET_END_DATE:
            return updateObject(state, { startDate: action.startDate, endDate: action.endDate })
        case actionTypes.CLEAR_END_DATE:
            return updateObject(state, { endDate: null })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/bookingEngine.js